
import { Validation } from "constants/Validation";
import * as Yup from "yup";

export const MemberBankDetailsSchema = 
Yup.object().shape({
    bankId: Yup.string(),
    accountHolderName: Yup.string().required(Validation.required.message.replaceAll("^","Account Holder Name"))
            .matches(Validation.plaintext.regex , Validation.plaintext.message), 
            accountNumber: Yup.string()
            .matches(/^\d{8,}$/, "Account Number must be at least 8 digits")
            .matches(Validation.accountNumber.regex, Validation.accountNumber.message) // Keep this properly chained
            .required(Validation.required.message.replaceAll("^", "Account Number")),
          
    bankName: Yup.string().required(Validation.required.message.replaceAll("^","Bank Name"))
            .matches(Validation.plaintext.regex , Validation.plaintext.message),
    countryId: Yup.string().required(Validation.required.message.replaceAll("^","Country")),
    currency: Yup.string().required(Validation.required.message.replaceAll("^","Currency")),
    branchName: Yup.string()
            .matches(Validation.plaintext.regex , Validation.plaintext.message),
    swiftCode: Yup.string()
            .matches(Validation.plaintext.regex , Validation.plaintext.message),
    iban: Yup.string()
            .matches(Validation.plaintext.regex , Validation.plaintext.message),
    routingNo: Yup.string()
            .matches(Validation.plaintext.regex , Validation.plaintext.message),
    type: Yup.string()
            .matches(Validation.plaintext.regex , Validation.plaintext.message),
    companyId: Yup.string()
            .matches(Validation.plaintext.regex , Validation.plaintext.message),
            
})
